module.exports = __webpack_public_path__ + "static/media/ChainBridgeAPI.js.04528981.map";